import { AxiosRequestConfig } from 'axios';
import { IToken } from 'interfaces/token';
import axios, { setAuthorizationToken } from 'services';
import { refreshToken as refreshTokenService } from 'services/auth';
import Fingerprint from 'utils/fingerprint';
import { removeTokenWithRedirect, setToken } from 'utils/token';

export const refreshToken = async (config?: AxiosRequestConfig): Promise<IToken | null> => {
	const fingerprint = await Fingerprint.get();

	try {
		const { data: token } = await refreshTokenService(fingerprint);
		setToken(token);
		setAuthorizationToken(token);
		if (config) {
			axios.request({
				...config,
				headers: {
					...config.headers,
					Authorization: `Bearer ${token.access_token}`,
				},
			});
		}
		return token;
	} catch (e) {
		removeTokenWithRedirect();
		return null;
	}
};
